import gql from 'graphql-tag';

import { printPartnerShippingOptionDetails } from '../../../../graphql/fragments/print-partner';

const getPrintPartnerShippingOptions = gql`
  query getPrintPartnerShippingOptions(
    $print_partner_id: RecordID!
    $vendor_account_id: RecordID
  ) {
    printPartners(print_partner_id: $print_partner_id) {
      records {
        id
        shipping_options(
          slice: { limit: 999 }
          vendor_account_id: $vendor_account_id
        ) {
          records {
            ...printPartnerShippingOptionDetails
          }
        }
      }
    }
  }
  ${printPartnerShippingOptionDetails}
`;

export default getPrintPartnerShippingOptions;
